import React from 'react';
import PropTypes from 'prop-types';
import ScrollArea from 'react-scrollbar/dist/no-css';

const ShopScrollWrapper = props => {
  const {
    className,
    children
  } = props;
  return (
    <ScrollArea
      stopScrollPropagation
      className={className}
      verticalContainerStyle={{display: 'none'}}
      smoothScrolling
      focusableTabIndex={-1}
    >
      {children}
    </ScrollArea>
  );
};

ShopScrollWrapper.propTypes = {
  className: PropTypes.any,
  contentClass: PropTypes.any,
};

export default ShopScrollWrapper;
